let current = Date.now();

export const nextId = () => `id--${current++}`;

export const toTwDate = (date, separator = "-") => {
    const matches = date?.match(/^(\d+)[\/-](\d+)[\/-](\d+)/);

    return matches ? `${parseInt(matches[1], 10) - 1911}${separator}${matches[2]}${separator}${matches[3]}` : "";
};
